import { useMutation } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'

import { getRecommendation } from '../api'

const useGetRecommendationMutation = () => {
  return useMutation<
    { variant_text: string },
    unknown,
    { productCategory: string; productName: string | undefined }
  >(getRecommendation, {
    onError: () => {
      errorToast('Something went wrong. Please try again.')
    },
  })
}

export default useGetRecommendationMutation
